import { Product, Table } from './types';
import { COOKIE_TOKEN_KEY } from './Constants';

export const getTokenFromCookies = (): string => {
    const cookie = document.cookie
        .split('; ')
        .find(c => c.startsWith(`${COOKIE_TOKEN_KEY}=`));
    return cookie ? cookie.split('=')[1] : undefined;
};

export const getTableCode = (tables: Table[], tableId: number): string =>
    tables.find(({ id }) => id === tableId)?.code;

export const getProductName = (products: Product[], productId: number): string =>
    products.find(({ id }) => id === productId)?.name;
